// import React, { useState } from 'react';
// import axios from 'axios';
// import Swal from 'sweetalert2';
// import { useNavigate } from 'react-router-dom';

// const WholesaleEnquiry = () => {
// const [formData, setFormData] = useState({
//   name: '',
//   email: '',
//   phone: '',
//   company_name: '',
//   message: '',
//   status: '' ,
// });


//   const [errors, setErrors] = useState({});
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const navigate = useNavigate();

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]: value
//     });

//     // Clear error on input
//     if (errors[name]) {
//       setErrors({ ...errors, [name]: '' });
//     }
//   };

//   const validate = () => {
//   const newErrors = {};

//   if (!formData.name.trim()) newErrors.name = 'Name is required';
  
//   if (!formData.phone.trim()) {
//     newErrors.phone = 'Phone number is required';
//   } else if (!/^[0-9]{10}$/.test(formData.phone)) {
//     newErrors.phone = 'Enter a valid 10-digit phone number';
//   }

//   if (!formData.message.trim()) {
//     newErrors.message = 'Message is required';
//   }

//   setErrors(newErrors);
//   return Object.keys(newErrors).length === 0;
// };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) return;

//     setIsSubmitting(true);

//     try {
      
//       const response = await axios.post(
//         'https://vantara.datacubeglobal.com/api/wholesale-enquiry',
//         formData
//       );

//       if (response.data.status === 'success') {
//         Swal.fire({
//           icon: 'success',
//           title: 'Thank You!',
//           text: 'Your wholesale enquiry has been submitted successfully. We will contact you shortly.',
//           confirmButtonText: 'Go Back',
//         }).then(() => {
//           navigate(-1);
//         });


//         setFormData({
//           name: '',
//           email: '',
//           mobile: '',
//           companyName: '',
//           businessType: '',
//           message: ''
//         });
//       } else {
//         throw new Error(response.data.message || 'Submission failed');
//       }
//     } catch (error) {
//       console.error('Error submitting form:', error);
//       Swal.fire({
//         icon: 'error',
//         title: 'Oops!',
//         text: error.response?.data?.message || 'Failed to submit. Please try again later.',
//         confirmButtonText: 'OK',
//       });
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   return (
//     <div className="container py-5">
//       <div className="row justify-content-center">
//         <div className="col-lg-8">
//           <div className="card shadow-sm border-0">
//             <div className="card-body p-4 p-md-5">
//               <h2 className="text-center mb-4 fw-bold">Wholesale Enquiry</h2>
//               <p className="text-center text-muted mb-4">
//                 Fill out the form below and our team will get back to you shortly.
//               </p>

//               <form onSubmit={handleSubmit}>
//                 {/* Name */}
//                 <div className="mb-3">
//                   <label htmlFor="name" className="form-label fw-medium">
//                     Full Name <span className="text-danger">*</span>
//                   </label>
//                   <input
//                     type="text"
//                     className={`form-control ${errors.name ? 'is-invalid' : ''}`}
//                     id="name"
//                     name="name"
//                     style={{ border: '1px solid #ced4da', borderRadius: '4px' }}
//                     value={formData.name}
//                     onChange={handleChange}
//                     placeholder="Enter your name"
//                   />
//                   {errors.name && <div className="invalid-feedback">{errors.name}</div>}
//                 </div>

        
//                 <div className="mb-3">
//                   <label htmlFor="email" className="form-label fw-medium">
//                     Email Address <span className="text-danger">*</span>
//                   </label>
//                   <input
//                     type="email"
//                     className={`form-control ${errors.email ? 'is-invalid' : ''}`}
//                     id="email"
//                     name="email"
//                     value={formData.email}
//                     onChange={handleChange}
//                     placeholder="you@example.com"
//                   />
//                   {errors.email && <div className="invalid-feedback">{errors.email}</div>}
//                 </div>

           
//              <div className="mb-3">
//   <label htmlFor="phone" className="form-label fw-medium">
//     Phone Number <span className="text-danger">*</span>
//   </label>
//   <input
//     type="tel"
//     className={`form-control ${errors.phone ? 'is-invalid' : ''}`}
//     id="phone"
//     name="phone"
//     value={formData.phone}
//     onChange={handleChange}
//     placeholder="10–15 digits"
//   />
//   {errors.phone && <div className="invalid-feedback">{errors.phone}</div>}
// </div>

                
//                 <div className="mb-3">
//   <label htmlFor="company_name" className="form-label fw-medium">
//     Company Name
//   </label>
//   <input

//     className="form-control"
//     id="company_name"
//     name="company_name"
//     value={formData.company_name}
//     onChange={handleChange}
//     placeholder="Your company or business name"
//   />
// </div>
                
//                 <div className="mb-3">
//                   <label htmlFor="businessType" className="form-label fw-medium">
//                     Type of Business <span className="text-danger">*</span>
//                   </label>
//                   <select
//                     className={`form-select ${errors.businessType ? 'is-invalid' : ''}`}
//                     id="businessType"
//                     name="businessType"
//                     value={formData.businessType}
//                     onChange={handleChange}
//                   >
//                     <option value="">Select your business type</option>
//                     <option value="Retailer">Retailer</option>
//                     <option value="Distributor">Distributor</option>
//                     <option value="Wholesaler">Wholesaler</option>
//                     <option value="E-commerce Store">E-commerce Store</option>
//                     <option value="Reseller">Reseller</option>
//                     <option value="Manufacturer">Manufacturer</option>
//                     <option value="Other">Other</option>
//                   </select>
//                   {errors.businessType && (
//                     <div className="invalid-feedback">{errors.businessType}</div>
//                   )}
//                 </div>

                
//                {/* Message */}
// <div className="mb-4">
//   <label htmlFor="message" className="form-label fw-medium">
//     Message <span className="text-danger">*</span>
//   </label>
//   <textarea
//     className={`form-control ${errors.message ? 'is-invalid' : ''}`}
//     id="message"
//     name="message"
//     rows="4"
//     value={formData.message}
//     onChange={handleChange}
//     placeholder="Tell us about your requirements"
//   ></textarea>
//   {errors.message && <div className="invalid-feedback">{errors.message}</div>}
// </div>
                
//                 <div className="d-grid" style={{ maxWidth: '200px', margin: '0 auto' }}>
//                   <button
//                     type="submit"
//                     className="btn py-1 px-4 fs-6 fw-semibold rounded-pill"
//                     disabled={isSubmitting}
//                     style={{ height: 'auto', minHeight: '36px' , backgroundColor: '#1C3F1D', color: '#fff' }}
//                   >
//                     {isSubmitting ? (
//                       <>
//                         <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
//                         Submitting...
//                       </>
//                     ) : (
//                       'Submit Enquiry'
//                     )}
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default WholesaleEnquiry;

import React from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';

const WholesaleEnquiry = () => {
  const navigate = useNavigate();

  // ✅ Validation Schema
  const validationSchema = Yup.object({
    name: Yup.string().trim().required('Full name is required'),
    email: Yup.string()
  .trim()
  .email('Enter a valid email')
  .matches(/^[\w.+-]+@gmail\.com$/, 'Email must be a Gmail address')
  .required('Email is required'),

    phone: Yup.string()
      .trim()
      .matches(/^[0-9]{10,15}$/, 'Enter a valid phone number (10–15 digits)')
      .required('Phone number is required'),
    company_name: Yup.string().trim().required('Company name is required'),
    businessType: Yup.string().required('Please select a business type'),
    message: Yup.string().trim().required('Message is required'),
  });

  // ✅ Formik Setup
  const formik = useFormik({
    initialValues: {
      name: '',
      email: '',
      phone: '',
      company_name: '',
      businessType: '',
      message: '',
    },
    validationSchema,
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      try {
        const response = await axios.post(
          'https://vantara.datacubeglobal.com/api/wholesale-enquiry',
          values
        );

        if (response.data.status === 'success') {
          Swal.fire({
            icon: 'success',
            title: 'Thank You!',
            text: 'Your wholesale enquiry has been submitted successfully. We will contact you shortly.',
            confirmButtonText: 'Go Back',
              confirmButtonColor: '#223626FF'

          }).then(() => navigate(-1));

          resetForm();
        } else {
          throw new Error(response.data.message || 'Submission failed');
        }
      } catch (error) {
        console.error('Error submitting form:', error);
        Swal.fire({
          icon: 'error',
          title: 'Oops!',
          text:
            error.response?.data?.message ||
            'Failed to submit. Please try again later.',
          confirmButtonText: 'OK',
        });
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-8">
          <div className="card shadow-sm border-0">
            <div className="card-body p-4 p-md-5">
              <h2 className="text-center mb-4 fw-bold">Wholesale Enquiry</h2>
              <p className="text-center text-muted mb-4">
                Fill out the form below and our team will get back to you
                shortly.
              </p>

              <form onSubmit={formik.handleSubmit}>
                {/* Full Name */}
                <div className="mb-3">
                  <label htmlFor="name" className="form-label fw-medium">
                    Full Name <span className="text-danger">*</span>
                  </label>
                  <input
                    // type="text"
                    id="name"
                    name="name"
                    className={`form-control ${
                      formik.touched.name && formik.errors.name
                        ? 'is-invalid'
                        : ''
                    }`}
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    placeholder="Enter your name"
                  />
                  {formik.touched.name && formik.errors.name && (
                    <div className="invalid-feedback">
                      {formik.errors.name}
                    </div>
                  )}
                </div>

                {/* Email */}
                <div className="mb-3">
                  <label htmlFor="email" className="form-label fw-medium">
                    Email Address <span className="text-danger">*</span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    className={`form-control ${
                      formik.touched.email && formik.errors.email
                        ? 'is-invalid'
                        : ''
                    }`}
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    placeholder="you@example.com"
                  />
                  {formik.touched.email && formik.errors.email && (
                    <div className="invalid-feedback">
                      {formik.errors.email}
                    </div>
                  )}
                </div>

                {/* Phone */}
                <div className="mb-3">
                  <label htmlFor="phone" className="form-label fw-medium">
                    Phone Number <span className="text-danger">*</span>
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    className={`form-control ${
                      formik.touched.phone && formik.errors.phone
                        ? 'is-invalid'
                        : ''
                    }`}
                    value={formik.values.phone}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    placeholder="10–15 digits"
                  />
                  {formik.touched.phone && formik.errors.phone && (
                    <div className="invalid-feedback">
                      {formik.errors.phone}
                    </div>
                  )}
                </div>

                {/* Company Name */}
                <div className="mb-3">
                  <label htmlFor="company_name" className="form-label fw-medium">
                    Company Name <span className="text-danger">*</span>
                  </label>
                  <input
                    // type="text"
                    id="company_name"
                    name="company_name"
                    className={`form-control ${
                      formik.touched.company_name && formik.errors.company_name
                        ? 'is-invalid'
                        : ''
                    }`}
                    value={formik.values.company_name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    placeholder="Your company or business name"
                  />
                  {formik.touched.company_name &&
                    formik.errors.company_name && (
                      <div className="invalid-feedback">
                        {formik.errors.company_name}
                      </div>
                    )}
                </div>

                {/* Business Type */}
                <div className="mb-3">
                  <label htmlFor="businessType" className="form-label fw-medium">
                    Type of Business <span className="text-danger">*</span>
                  </label>
                  <select
                    id="businessType"
                    name="businessType"
                    className={`form-select ${
                      formik.touched.businessType && formik.errors.businessType
                        ? 'is-invalid'
                        : ''
                    }`}
                    value={formik.values.businessType}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  >
                    <option value="">Select your business type</option>
                    <option value="Retailer">Retailer</option>
                    <option value="Distributor">Distributor</option>
                    <option value="Wholesaler">Wholesaler</option>
                    <option value="E-commerce Store">E-commerce Store</option>
                    <option value="Reseller">Reseller</option>
                    <option value="Manufacturer">Manufacturer</option>
                    <option value="Other">Other</option>
                  </select>
                  {formik.touched.businessType &&
                    formik.errors.businessType && (
                      <div className="invalid-feedback">
                        {formik.errors.businessType}
                      </div>
                    )}
                </div>

                {/* Message */}
                <div className="mb-4">
                  <label htmlFor="message" className="form-label fw-medium">
                    Message <span className="text-danger">*</span>
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    rows="4"
                    className={`form-control ${
                      formik.touched.message && formik.errors.message
                        ? 'is-invalid'
                        : ''
                    }`}
                    value={formik.values.message}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    placeholder="Tell us about your requirements"
                  ></textarea>
                  {formik.touched.message && formik.errors.message && (
                    <div className="invalid-feedback">
                      {formik.errors.message}
                    </div>
                  )}
                </div>

                {/* Submit Button */}
                <div
                  className="d-grid"
                  style={{ maxWidth: '200px', margin: '0 auto' }}
                >
                  <button
                    type="submit"
                    className="btn py-1 px-4 fs-6 fw-semibold rounded-pill"
                    disabled={formik.isSubmitting}
                    style={{
                      height: 'auto',
                      minHeight: '36px',
                      backgroundColor: '#1C3F1D',
                      color: '#fff',
                    }}
                  >
                    {formik.isSubmitting ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Submitting...
                      </>
                    ) : (
                      'Submit Enquiry'
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WholesaleEnquiry;
